import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  // Check if mobile
  const isMobile = window.innerWidth <= 600;
  
  return (
    <a
      href="https://wa.me/9030064343"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      style={{ 
        display: 'flex',
        position: 'fixed',
        right: isMobile ? '8px' : '28px',
        bottom: isMobile ? '80px' : '100px',
        zIndex: 10000,
        background: '#25d366',
        color: '#fff',
        borderRadius: '50%',
        width: '56px',
        height: '56px',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
        textDecoration: 'none'
      }}
    >
      <FaWhatsapp size={36} />
    </a>
  );
};

export default WhatsAppButton; 